import { CapitalCatalogo, CoberturaCatalogo, PreguntaCatalogo } from '../../comun/model/catalogo.model';
import { Capital, Cobertura, Pregunta } from '../../comun/model/poliza.model';

export class PolizaUtils {

    static mapCapitales(formValues: Record<string, any>, capitalesCtlg: CapitalCatalogo[]): Capital[] {
        return capitalesCtlg
            .map(({ idCapital }) => {
                const respuesta = formValues[`cap_${idCapital}`];
                if (respuesta !== undefined && respuesta >= 0) {
                    return {
                        idCapital,
                        importeCapital: respuesta
                    } as Capital;
                }
                return null;
            })
            .filter((capital): capital is Capital => capital !== null);
    }

    static mapPreguntas(formValues: Record<string, any>, preguntasCtlg: PreguntaCatalogo[]): Pregunta[] {
        return preguntasCtlg
            .map(({ tipoRespuesta, idPregunta }) => {
                const respuesta = formValues[`preg_${idPregunta}`];

                if (tipoRespuesta === '1') {
                    if (respuesta !== undefined && respuesta !== null) {
                        return { idPregunta, respuesta: respuesta === 1 } as Pregunta;
                    }
                } else if (tipoRespuesta === '2') {
                    if (respuesta && respuesta !== '') {
                        return { idPregunta, respuesta: String(respuesta) } as Pregunta;
                    }
                } else if (tipoRespuesta === '3' || tipoRespuesta === '4') {
                    const numericValue = Number(respuesta);
                    if (!isNaN(numericValue) && numericValue > 0) {
                        return { idPregunta, respuesta: numericValue } as Pregunta;
                    }
                } else if (tipoRespuesta === '5') {
                    if (respuesta) {
                        return { idPregunta, respuesta: new Date(respuesta) } as Pregunta;
                    }
                } else if (tipoRespuesta === '6') {
                    if (respuesta && respuesta !== '') {
                        return { idPregunta, respuesta } as Pregunta;
                    }
                } else if (respuesta !== undefined) {
                    if (respuesta)
                    return { idPregunta, respuesta } as Pregunta;
                }

                return null;
            })
            .filter((pregunta): pregunta is Pregunta => pregunta !== null);
    }

    static mapCoberturas(formValues: Record<string, any>, coberturasCtlg: CoberturaCatalogo[]): Cobertura[] {
        return coberturasCtlg
            .map(({ idCobertura }) => {
                const respuesta = formValues[`cob_${idCobertura}`];
                if (respuesta === 1) {
                    return { idCobertura } as Cobertura;
                }
                return null;
            })
            .filter((cobertura): cobertura is Cobertura => cobertura !== null);
    }

    static getFormValuesByPrefix(
		formValues: Record<string, any>,
		prefix: string
	): Record<string, any> {
		return Object.entries(formValues)
			.filter(([key]) => key.startsWith(prefix))
			.reduce((acc, [key, value]) => {
				acc[key] = value;
				return acc;
			}, {} as Record<string, any>);
	}
}